import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { useMultiStepForm } from "./MultiStepFormContext";

const STEP_LABELS = [
  { step: "service", label: "Service" },
  { step: "details", label: "Details" },
  { step: "contact", label: "Contact" },
];

export function FormProgress() {
  const { currentStepIndex, currentStep } = useMultiStepForm();

  // Don't show progress on success step
  if (currentStep === "success") {
    return null;
  }

  return (
    <div className="mb-8">
      {/* Progress bar */}
      <div className="relative h-1 bg-[var(--dug-border)] rounded-full overflow-hidden mb-4">
        <motion.div
          className="absolute inset-y-0 left-0 bg-[var(--dug-coral)] rounded-full"
          initial={{ width: 0 }}
          animate={{ width: `${((currentStepIndex + 1) / STEP_LABELS.length) * 100}%` }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
        />
      </div>

      {/* Step indicators */}
      <div className="flex justify-between">
        {STEP_LABELS.map((item, index) => {
          const isCompleted = index < currentStepIndex;
          const isCurrent = index === currentStepIndex;

          return (
            <div key={item.step} className="flex flex-col items-center">
              <div
                className={`
                  w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium transition-all
                  ${isCompleted
                    ? "bg-[var(--dug-coral)] text-[var(--dug-text-inverse)]"
                    : isCurrent
                      ? "bg-[var(--dug-coral)] text-[var(--dug-text-inverse)]"
                      : "bg-[var(--dug-bg-surface)] border-2 border-[var(--dug-border)] text-[var(--dug-text-muted)]"
                  }
                `}
              >
                {isCompleted ? (
                  <Check className="w-4 h-4" />
                ) : (
                  index + 1
                )}
              </div>
              <span
                className={`
                  text-xs mt-2 font-medium
                  ${isCurrent
                    ? "text-[var(--dug-coral)]"
                    : isCompleted
                      ? "text-[var(--dug-text-primary)]"
                      : "text-[var(--dug-text-muted)]"
                  }
                `}
              >
                {item.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
